import { createReducer, on } from '@ngrx/store';

import { StateUtils } from '@state/state-utils';
import * as CustomerActions from './customer.actions';
import { CustomerState, initialCustomerState } from './customer.state';

const customerReducer = createReducer<CustomerState>(
  initialCustomerState,

  on(CustomerActions.fetchCustomersSuccess, (state, { customers }) => ({
    ...state,
    customers,
    fetchedAt: new Date(),
  })),
  on(CustomerActions.fetchCustomerByIdSuccess, (state, { customer }) => ({
    ...state,
    customers: StateUtils.combineState(state.customers, customer),
    fetchedAt: new Date(),
  })),
  on(
    CustomerActions.updateCustomerSuccess,
    CustomerActions.updateCustomerImageSuccess,
    (state, { customer }) => ({
      ...state,
      customers: StateUtils.combineState(state.customers, customer),
    })
  ),
  on(
    CustomerActions.fetchCustomersFailed,
    CustomerActions.fetchCustomerByIdFailed,
    (state, { error }) => ({
      ...state,
      fetchedAt: new Date(),
    })
  )
);

export { customerReducer };

